import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { TextField, useMediaQuery } from '@material-ui/core';
import { Values } from '../../../../values/Values';
import clsx from 'clsx';
import DialogContent from '@material-ui/core/DialogContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { useTheme } from '@material-ui/styles';
import { TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import { putEmpresa } from '../../../../services/EmpresaService';
import { useStyles } from './SobreSistemaStyles';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import Divider from '@material-ui/core/Divider';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function SobreSistema(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,

  } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={!isDesktop}
        TransitionComponent={Transition}
        className={clsx({
            [classes.root]: true
          }
        )}
      >
        <AppBar className={classes.appBar} color={'transparent'} variant={'outlined'}>
          <Toolbar>
            <Typography variant="h6" className={classes.title} >Configurações de visita</Typography>
            <IconButton edge="end" color="primary" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid
            container
            spacing={1}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao]: true
                })}
              >
                Esse sistema foi desenvolvido pela equipe da RG Softwares com intuito de atender as necessidades
                do Clube de Tiro de Garanhuns.
                para manter as alterações.
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Responsável:
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                Elyson Romeiro
              </Typography>
            </Grid>
            <Grid
              item
              md={4}
              xs={4}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Email:
              </Typography>
            </Grid>
            <Grid
              item
              md={8}
              xs={8}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                elysonromeiro090@gmail.com
              </Typography>
            </Grid>
            <Grid
              item
              md={4}
              xs={4}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Contato:
              </Typography>
            </Grid>
            <Grid
              item
              md={8}
              xs={8}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                (87) 9.9601-3273
              </Typography>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <Divider variant="middle"/>
            </Grid>

            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Responsável:
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                Gabrielle Amorim
              </Typography>
            </Grid>
            <Grid
              item
              md={4}
              xs={4}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Email:
              </Typography>
            </Grid>
            <Grid
              item
              md={8}
              xs={8}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                gabrielleporto19@gmail.com
              </Typography>
            </Grid>
            <Grid
              item
              md={4}
              xs={4}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Contato:
              </Typography>
            </Grid>
            <Grid
              item
              md={8}
              xs={8}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                (87) 9.9993-6286
              </Typography>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <Divider variant="middle"/>
            </Grid>

            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Versão:
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                {Values.versao.descricao}
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao2]: true
                })}
              >
                Data ultima atualização:
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
            >
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                component='h5'
                className={clsx({
                  [classes.textoInstrucao3]: true
                })}
              >
                {Values.versao.dataUltimaAtualizacao}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
  );
}

export default SobreSistema;
